import { Column, Row, Skeleton } from 'components/Blocks';

export function LoadingTaskModal() {
  return (
    <Column className="p-2">
      <Row justifyContent="space-between" alignItems="flex-start" className="overflow-hidden">
        <Column>
          <Row className="overflow-hidden">
            <Skeleton width="220px" />
            <Skeleton width="70px" />
          </Row>

          <Row>
            <Skeleton width="60px" />
            <Skeleton width="90px" />
            <Skeleton width="30px" />
          </Row>
        </Column>

        <Skeleton circle width={84} height={84} className="flex-shrink-0 phone:!size-14" />
      </Row>

      <div className="mt-2">
        <Skeleton width="90px" quantity={3} orientation="horizontal" />
      </div>

      <Skeleton height={90} className="mt-2" />

      <Skeleton height={265} className="mt-2" />

      <Skeleton height={50} quantity={2} />
    </Column>
  );
}
